import { Component, OnInit } from '@angular/core';
import { RouterOutlet, Router, NavigationEnd } from '@angular/router';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {
  public showWhatsApp: boolean = false;

  private readonly VISIBLE_ROUTES = ['login', 'inicio'];

  constructor(private router: Router) {}

  ngOnInit(): void {
    this.updateWhatsAppVisibility(this.router.url);
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.updateWhatsAppVisibility(event.url);
      }
    });
  }

  private updateWhatsAppVisibility(url: string): void {
    this.showWhatsApp = this.VISIBLE_ROUTES.some(route => url.includes(route));
  }

  goToWhatsAppTaller(): void {
    window.open('https://api.whatsapp.com/send/?phone=543513772531&text=%C2%A1Hola+Bonafe!+tengo+una+consulta+sobre+taller/reparaciones...&type=phone_number&app_absent=0', '_blank');
  }

  goToWhatsAppRepuestos(): void {
    window.open('https://api.whatsapp.com/send/?phone=543513129614&text=%C2%A1Hola+Bonafe!+tengo+una+consulta+sobre+repuestos...&type=phone_number&app_absent=0', '_blank');
  }
}
